<app-header title="Manage Campaigns"></app-header>
<div class="container pt-5 mt-5">
    <div id="selectCampaignType">
        <div class="row">
            <div class="col-12">
                <h4>Select Campaign type</h4>
            </div>
        </div>
        <div *ngFor="let deck of data" class="row">
            <div *ngFor="let campaign of deck.list" class="col-6">
                <div class="campaign-type cursor-pointer d-flex align-items-center" [ngClass]="{'campaign-type--selected': campaign.selected}" (click)="onSelect(campaign)">
                    <div *ngIf="!campaign.selected" class="campaign-type__unselected mr-2"></div>
                    <svg *ngIf="campaign.selected" class="campaign-type__selected mr-2" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Oval</title>
                        <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Campiagn-type-cell" transform="translate(-14.000000, -57.000000)">
                                <g>
                                    <circle id="Oval" stroke-opacity="0.110549607" stroke="#000026" cx="25" cy="68" r="10"></circle>
                                    <g id="Selection">
                                        <rect id="Rectangle" stroke="#25C157" stroke-width="2" x="0" y="0" width="386" height="136" rx="7"></rect>
                                        <path d="M23.4706625,72.1552419 C23.5178381,72.1314122 23.5620889,72.0998023 23.6014921,72.0603986 L30.6397097,65.0220417 C30.8389448,64.8228028 30.8395982,64.4992555 30.6404473,64.3001008 L30.2787227,63.9383691 C30.0802512,63.7398936 29.7563542,63.7395444 29.5567959,63.9391065 L23.2397766,70.2562506 L20.443227,67.4596458 C20.2427326,67.2591475 19.9202293,67.2595316 19.7210784,67.4586863 L19.3593538,67.820418 C19.1608823,68.0188935 19.1606325,68.3428962 19.3603133,68.542581 L22.8778393,72.0601765 C23.0390772,72.2214176 23.2792232,72.2527401 23.4706625,72.1552419 Z M15,68 C15,62.4771526 19.4759382,58 25,58 C30.5228475,58 35,62.4759382 35,68 C35,73.5228474 30.5240618,78 25,78 C19.4771525,78 15,73.5240618 15,68 Z" id="Shape" fill="#25C157" fill-rule="nonzero"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <img [src]="campaign.imageUrl" width="130px" height="auto" />
                    <div class="ml-3">
                        <div class="campaign-type__name mb-2">{{campaign.name}}</div>
                        <div class="campaign-type__description">{{campaign.description}}</div>
                        <div class="campaign-type__confirm justify-content-end">
                            <button class="btn btn--paybee btn--success" (click)="onConfirm(campaign)" [disabled]="confirmDisabled">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>